import { Record } from 'immutable';

/**
 * Описывает тип полученных данных
 * data сами данные
 * isLoading флаг загрузки
 * время последней загрузки если 0 загрузки не было
 * error описание ошибки
 */
export type FetchedDataObj<T, P = void> = {
  data: T | null;
  payload?: P | null;
  hasMore?: boolean;
  isLoading: boolean;
  saved?: boolean;
  LTU: number;
  error: {
    isError: boolean;
    message: string;
    code?: number;
    errorLogCode?: string;
    fields?: string[];
  };
};

export type FetchedData<T, P = void> = Record<FetchedDataObj<T, P>>;
/**
 * генерирует обьект FetchedData с данными по умолчанию
 */
export function genFetchedData<T, P = void>(
  data: T | null,
  payload?: P | null,
  hasMore?: boolean
): FetchedData<T, P> {
  const initData: FetchedDataObj<T, P> = {
    data,
    payload,
    hasMore,
    isLoading: false,
    saved: false,
    LTU: 0,
    error: {
      isError: false,
      message: '',
      code: 0,
      fields: [],
    },
  };
  const FetchedDataF: Record.Factory<FetchedDataObj<T, P>> = Record(initData);
  return new FetchedDataF();
}
